// N4-1 emotion-moment trigger logic, extracted as pure functions so the "which
// tier fires / does it fire at all" decisions are unit-testable without a full
// league + idb harness (same pattern as genFeedbackMessage.ts). The hooks in
// updatePlayoffSeries.ts / updateClinchedPlayoffs.ts call these.

export type PlayoffWinKind = "championship" | "advancement" | "none";

// Classify a completed playoff series from the user team's perspective. Winning
// the final round is a championship (→ L3 celebration); winning any earlier real
// round is an advancement (→ L2 highlight); everything else (a loss, a non-user
// series, or a play-in "round" at currentRound -1) is "none". Series complete
// exactly once, so callers need no extra dedup.
export const classifyUserPlayoffWin = ({
	winnerTid,
	userTid,
	currentRound,
	numRounds,
}: {
	winnerTid: number;
	userTid: number;
	currentRound: number;
	numRounds: number;
}): PlayoffWinKind => {
	const userWonRealRound = winnerTid === userTid && currentRound >= 0;
	if (!userWonRealRound) {
		return "none";
	}
	return currentRound === numRounds - 1 ? "championship" : "advancement";
};

const BERTH_STATUSES = new Set(["w", "x", "y", "z"]);

// True only when a team crosses from "no berth" into a berth-clinching status
// (play-in / playoffs / bye / #1 seed) for the first time. Upgrades between
// berth statuses (e.g. x → z) and elimination ("o") return false, so the L2
// clinch highlight fires at most once per season.
export const isFirstBerthClinch = ({
	prevStatus,
	newStatus,
}: {
	prevStatus: string | undefined;
	newStatus: string | undefined;
}): boolean =>
	newStatus !== undefined &&
	BERTH_STATUSES.has(newStatus) &&
	!(prevStatus !== undefined && BERTH_STATUSES.has(prevStatus));
